import { PeerComparisonResult } from "@/components/layouts/LeadAnalysis/types";
import { SalesVsQuotaData } from "@/entities/reporting/types";

export const extractPeerComparison = (
  data: SalesVsQuotaData
): PeerComparisonResult => {
  if (!data.salesVsQuota || !data.salesVsQuota?.overall?.quotaAchievement) {
    return {
      you: { value: 0 },
      team: { value: 0 },
      org: { value: 0 },
      industry: { value: 0 }
    };
  }

  const overallData = data.salesVsQuota.overall.quotaAchievement;

  return {
    you: {
      value: overallData.you
    },
    team: {
      value: overallData.team
    },
    org: {
      value: overallData.org
    },
    industry: {
      value: overallData.industry || 0
    }
  };
};
